import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from "@tanstack/react-query";
import { getFees, acceptFees } from "@/api/v1-jwt/provider-onboarding/provider-onboarding";
import { AcceptFeesPayload, FeesResponse } from "./types";
import providerOnboardingQueryKeys from "./query-keys";

export const useFees = (
  userId: string,
  applicationId: string,
  providerType: string,
  options?: Omit<UseQueryOptions<FeesResponse, Error>, "queryKey" | "queryFn">
) => {
  return useQuery<FeesResponse, Error>({
    queryKey: providerOnboardingQueryKeys.fees(userId, applicationId, providerType),
    queryFn: () => getFees(userId, applicationId, providerType),
    enabled: !!userId && !!applicationId && !!providerType,
    staleTime: Infinity,
    ...options,
  });
};

interface AcceptFeesParams {
  userId: string;
  applicationId: string;
  providerType: string;
  payload: AcceptFeesPayload;
}

export const useAcceptFees = (
  options?: UseMutationOptions<unknown, Error, AcceptFeesParams>
) => {
  return useMutation<unknown, Error, AcceptFeesParams>({
    mutationFn: ({ userId, applicationId, providerType, payload }) =>
      acceptFees(userId, applicationId, providerType, payload),
    ...options,
  });
};
